// Every `ReviewContext<ReviewTypeApi.CONTEST>` builder must normalize `seoUrl` the same way, or the datastore fails to merge review documents.
export function normalizeContestReviewSeoUrl(seoUrl: string): string {
  const strippedSeoUrl = seoUrl.replace(/\.html$/g, '');
  return strippedSeoUrl && !strippedSeoUrl.startsWith('/')
    ? `/${strippedSeoUrl}`
    : strippedSeoUrl;
}
